
module.exports = [
  'M4 12 A12 12 0 0 1 28 12 C28 20, 16 32, 16 32 C16 32, 4 20 4 12 M11 12 A5 5 0 0 0 21 12 A5 5 0 0 0 11 12 Z'
].join(' ')




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/paths/pin.js
// module id = 341
// module chunks = 6